import type { TabKey } from '~/Partials/TabList/Tab';
import { replaceNotFriendlyCharacters } from '~/Partials/Utils/utils';

export const buildTabId = (tabKey: TabKey) => `tab_${replaceNotFriendlyCharacters(tabKey.toString().toLowerCase())}`;
export const buildTabPanelId = (tabKey: TabKey) =>
    `tabPanel_${replaceNotFriendlyCharacters(tabKey.toString().toLowerCase())}`;
